import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from '../../translations/proposals';
import Breadcrumb from '../../../Breadcrumb';

interface ProposalDetailBreadCrumbsProps {
  lineItemNumber?: string;
}

export const ProposalDetailBreadCrumbs = ({ lineItemNumber }: ProposalDetailBreadCrumbsProps) => (
  <Breadcrumb>
    <Breadcrumb.Item to="../..">
      <FormattedMessage id="account.index.title" defaultMessage="My account" />
    </Breadcrumb.Item>
    <Breadcrumb.Item isCurrentPage>
      <FormattedMessage {...messages.proposalDetailTitle} />
      {' '}
      {lineItemNumber || '...'}
    </Breadcrumb.Item>
  </Breadcrumb>
);
